<template>
	<div>
		<input
			v-for="(val, index) in data.options"
			:value="val.name"
			:key="index"
			:name="name"
			type="hidden"
		/>
	</div>
</template>

<script>
import { mutations } from "../store";

export default {
	data() {
		return {
			hiddenOpts: this.data.options[0]
		};
	},

	mounted() {
		if (this.name == "size") {
			mutations.setSizeFactor(this.hiddenOpts.multiplier);
			mutations.setSizeSquareInches(
				this.hiddenOpts.width,
				this.hiddenOpts.length
			);
		}

		if (this.name == "coating") {
			mutations.setCoatingCharge(this.hiddenOpts.multiplier);
		}
	},

	props: {
		data: {
			type: Object,
			required: true
		},

		name: {
			type: String,
			required: true
		}
	}
};
</script>
